module.exports = __webpack_public_path__ + "brand-icons.5ad3d5d4a4d6acd64df9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brand-icons/brand-icons.svg?v=0.3.2
// module id = 689
// module chunks = 3